import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCustomTheme } from "../../../../core/design-system/CustomThemeProvider.js";
import { iconSize, radius, spacing, } from "../../../../core/design-system/index.js";
import { useActiveAccount } from "../../../../core/hooks/wallets/useActiveAccount.js";
import { shortenString } from "../../../../core/utils/addresses.js";
import { CopyIcon } from "../../components/CopyIcon.js";
import { QRCode } from "../../components/QRCode.js";
import { Spacer } from "../../components/Spacer.js";
import { WalletImage } from "../../components/WalletImage.js";
import { Container, ModalHeader } from "../../components/basic.js";
import { Text } from "../../components/text.js";
import { StyledButton } from "../../design-system/elements.js";
import { useClipboard } from "../../hooks/useCopyClipboard.js";
/**
 *
 * @internal
 */
export function ReceiveFunds(props) {
    const account = useActiveAccount();
    const address = account?.address;
    const { hasCopied, onCopy } = useClipboard(address || "");
    const { connectLocale, client } = props;
    const locale = connectLocale.receiveFundsScreen;
    return (_jsxs(Container, { p: "lg", children: [_jsx(ModalHeader, { title: locale.title, onBack: props.onBack }), _jsx(Spacer, { y: "xl" }), _jsx(Container, { flex: "row", center: "x", children: _jsx(QRCode, { qrCodeUri: address, size: 310, QRIcon: props.walletId && (_jsx(WalletImage, { id: props.walletId, size: iconSize.xxl, client: client })) }) }), _jsx(Spacer, { y: "xl" }), _jsxs(WalletAddressContainer, { onClick: onCopy, children: [_jsx(Text, { color: "primaryText", size: "md", children: shortenString(address || "") }), _jsx(CopyIcon, { text: address || "", tip: "Copy address", hasCopied: hasCopied })] }), _jsx(Spacer, { y: "lg" }), _jsx(Text, { multiline: true, center: true, balance: true, children: locale.instruction })] }));
}
const WalletAddressContainer = /* @__PURE__ */ StyledButton((_) => {
    const theme = useCustomTheme();
    return {
        all: "unset",
        width: "100%",
        boxSizing: "border-box",
        cursor: "pointer",
        padding: spacing.md,
        display: "flex",
        justifyContent: "space-between",
        border: `1px solid ${theme.colors.borderColor}`,
        borderRadius: radius.md,
        transition: "border-color 200ms ease",
        "&:hover": {
            borderColor: theme.colors.accentText,
        },
    };
});
//# sourceMappingURL=ReceiveFunds.js.map